export const RNC_LINKS_RECEIVED = 'RNC_LINKS_RECEIVED'
export const RNC_LINKS_DELETED = 'RNC_LINKS_DELETED'
export const RNC_LINKS_UNLOADED = 'RNC_LINKS_UNLOADED'